'use client';

import { CircularLoader } from '@northladder/design-system';
import { Text, useTranslations } from '@northladder/i18n';

import { DisplayDeviceName } from '../DisplayDeviceName';

interface IAssessmentCompleteFailedProps {
  evaluationId: string;
}

/**
 * -----------------------------------------------------------------------------
 * This is rendered when the user is submitting the assessment.
 * TODO: Add better loading state indicators.
 */
export function AssessmentSubmitting({
  evaluationId,
}: IAssessmentCompleteFailedProps) {
  const t1 = useTranslations('FunctionalAssessmentComplete');
  const t = useTranslations('FunctionalAssessmentComplete.loadingScreen');

  return (
    <div className="flex flex-col items-center justify-center gap-10 pt-8">
      <div className="flex flex-col items-center justify-center gap-2 px-4">
        <p
          className="
            text-body-text text-center text-base font-medium leading-tight
          "
        >
          {t('introText')}
        </p>
        <h1 className="text-center text-2xl font-bold leading-8">
          {t1('title')}
        </h1>
        <div className="text-primary-700 text-center text-sm font-bold leading-4 opacity-95">
          {t('subTitle')}
          <DisplayDeviceName evaluationId={evaluationId} />
        </div>
      </div>

      <CircularLoader className="my-20 h-24 w-24 p-8 sm:my-40" />

      <div
        className="
          flex max-w-xs flex-col items-center justify-center gap-2 pb-10
          text-center text-sm font-normal leading-5
        "
      >
        <p className="text-primary-500 flex flex-col">
          {t('instructionLine1')}
        </p>
        <hr className="my-2 w-full border-gray-400/10" />
        <Text
          className=" text-primary-600 text-xs"
          text={t('instructionLine2')}
        />
      </div>
    </div>
  );
}
